import { formatMoney } from './chunk-V5NTXSTJ.mjs';

// src/helpers/factories/customers/customersMainScreenTableFactory.ts
var customersMainScreenTableFactory = (customers) => Object.values(customers).map((customer) => ({
  id: customer.customerId,
  title: `${customer.lastName}, ${customer.firstName}`,
  email: customer.email || "-",
  phoneNumber: `(${customer.phoneNumber.substring(0, 3)}) ${customer.phoneNumber.substring(3, 6)} ${customer.phoneNumber.substring(6, customer.phoneNumber.length)}`,
  avgSpend: formatMoney(null, customer.avgSpend),
  lifetimeSpend: formatMoney(null, customer.lifetimeSpend)
}));

export { customersMainScreenTableFactory };
